import React from 'react';
import Joi from 'joi-browser';
import Form from '../../../common/form';

class BuyForm extends Form {
	state = {
		data: {
			nft: '',
			securityPassword: '',
		},
		errors: {},
	};

	schema = {
		nft: Joi.string().required().label('NFT'),
		securityPassword: Joi.string().required().label('Security Password'),
	};

	doSubmit = () => this.props.onSubmit(this.state.data);

	componentDidUpdate(prevProps, prevState) {
		if (
			this.props.isSubmited === true &&
			prevProps.isSubmited !== this.props.isSubmited
		) {
			const state = { ...this.state };
			state.data = {
				nft: '',
				securityPassword: '',
			};
			this.setState(state);
		}
		if (prevProps.errors !== this.props.errors) {
			const state = { ...this.state };
			state.errors = this.props.errors;
			this.setState(state);
		}
	}

	componentWillUnmount() {
		// fix Warning: Can't perform a React state update on an unmounted component
		this.setState = (state, callback) => {
			return;
		};
	}

	render() {
		const { isLoading, hasSP, nfts } = this.props;
		return (
			<form
				className='text-start'
				autoComplete='off'
				onChange={this.props.onFormChange}
				onSubmit={this.handleSubmit}>
				<div className='mb-3'>
					{this.renderSelectNormal({
						name: 'nfts',
						label: 'Select NFT',
						options: nfts,
					})}
				</div>

				{this.renderSubmitBtnWithSPass({
					divClass: 'mb-3',
					hasSP,
					isLoading,
					text: 'Submit',
					loadingText: 'Submitting...',
				})}
			</form>
		);
	}
}

export default BuyForm;
